<template>
    <div class="container mt-5" style="padding-top:100px">
        <div id="jobfair-preview">
            <b-card
                :title="jobfair.job_fair_name"
                img-alt="Image"
                img-top style="color:rgb(71 65 119)">
                <b-card-text >
                    <div class="d-flex row mb-5 justify-content-around mt-5">
                        <div class="col-8 p-4" style="background-color: #f7f7f7">
                            <p><span class="jobfair_label">Date:</span> From {{jobfair.job_fair_start_date}} to {{jobfair.job_fair_end_date}}</p>
                            <p v-if="jobfair.city" class="mb-0"><span class="jobfair_label">City:</span> {{jobfair.city}}</p>
                            <p v-if="jobfair.address" class="mb-0"><span class="jobfair_label">Address:</span> {{jobfair.address}}</p>
                            <p v-if="jobfair.location_url" class="mb-0"><span class="jobfair_label">Location url:</span> {{jobfair.location_url}}</p>
                            <p v-if="jobfair.qualification_req_for_jobfair" class="mb-0"><span class="jobfair_label">Minimum qualification required:</span> {{jobfair.qualification_req_for_jobfair}}</p>
                            <p v-if="jobfair.details" class="mb-0"><span class="jobfair_label">About</span></p>
                            <div v-html="jobfair.details"></div>
                            <p v-if="jobfair.faq" class="mb-0"><span class="jobfair_label">FAQ:</span></p>
                            <div v-if="jobfair.faq" v-html="jobfair.faq"></div>
                            <a :href="'//'+ vue_app_url_raw + '/jobfair/'+jobfair.job_fair_url" target="_blank" style="text-decoration:underline">Visit jobfair page</a>
                        
                        </div>
                        <div class="col-lg-3 p-4" style="background-color: #f7f7f7">
                            <h5 style="font-weight:bold">Organized by</h5>
                            <div>
                                <p class="mb-0" style="text-transform: capitalize">{{jobfair.organizer_name}}</p>
                                <p class="mb-0">Ph: {{jobfair.organizer_phone}}</p>
                                <p class="mb-0">Email: {{jobfair.organizer_mail}}</p>

                                <button class="btn btn-primary mt-5"><a :href="'/recruit/jobfair/manage_jobs/'+jobfair.id" style="color:inherit;text-decoration:none">Add Jobs to Jobfair</a></button>
                            </div>
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'preview_jobfair',
    beforeMount() {
        // console.log(this.$route.params.id);
        this.token = this.$cookies.get("hire-employer").token;
        new this.$apiAction().showJobfair(this.$route.params.id, this.token).then((res) => {
            this.jobfair =  res.jobfair;
            this.jobfair.job_fair_start_date = this.getDate(res.jobfair.job_fair_start_date);
            this.jobfair.job_fair_end_date = this.getDate(res.jobfair.job_fair_end_date);
            console.log(res)
        }).catch((err) => {
            console.log(err)
        });
    },
    data() {
        return {
            token: null,
            vue_app_url_raw : process.env.VUE_APP_URL_RAW,
            jobfair: {
                job_fair_name: "",
                job_fair_banner_path: "",
                job_fair_logo: "",
                job_fair_url: "",
                qualification_req_for_jobfair: "",
                city: null,
                organizer_name: "",
                organizer_phone: "",
                organizer_mail: "",
                link_for_registration: "",
                job_fair_start_date: null,
                job_fair_end_date: null,
                address: "",
                faq: "",
                participants_logo: "",
                details: "",
                location_url: null,
                application_sequence_id: 0
            },
        }
    },
    methods: {
        getDate(ts){
            var timestamp = ts * 1000;
            var date = new Date(timestamp);
            return date.getDate()+
                "-"+(date.getMonth()+1)+
                "-"+date.getFullYear()
        },
    }
}
</script>
<style>
    #jobfair-preview .card-title {
        padding-left: 0.5rem;
        font-size: 1.5rem;
        font-weight: bold;
    }
    .jobfair_label {
        font-weight: bold;
        margin-right: 0.5rem;
    }
</style>